function migrateTo1(state: any) {
  return { ...state, flow: { ...state.flow, appSpacing: {} } };
}

export default migrateTo1;
